import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../services/useAuth";
import { translate } from "../../../hooks/translate";

import Input from "../../../components/BaseUI/Input";
import Button from "../../../components/BaseUI/Button";

import styles from "./Login.module.scss";
import { useTitle } from "../../../hooks/useTitle";
import { Toast, ToastContainer } from "../../../components/CustomUI/Toast";
import { FiUser, FiLock, FiLogIn, FiActivity, FiLayers, FiShield } from "react-icons/fi";

export default function Login() {
  useTitle("Rovion MES - Giriş");

  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    try {
      setLoading(true);
      setError(null);

      const response = await login(formData.email, formData.password);

      if (response.success) {
        setTimeout(() => {
          try {
            window.location.href = "/";
          } catch (redirectError) {
            navigate("/");
          }
        }, 500);
      } else {
        setError(
          response.message ||
            "Giriş başarısız. Lütfen bilgilerinizi kontrol edin."
        );
      }
    } catch (error) {
      setError(
        error.message || "Bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles["login-container"]}>
      {/* Left side - Branding */}
      <div className={styles["login-brand"]}>
        <div className={styles["brand-content"]}>
          <h1 className={styles["brand-title"]}>Endüstriyel Üretim Yönetim Sistemi</h1>
          <p className={styles["brand-subtitle"]}>
            Fabrika içi üretim süreçlerini anlık takip edin, cihazlarınızı yönetin ve verimliliği maksimize edin.
          </p>
          
          <div className={styles["brand-features"]}>
            <div className={styles["feature-item"]}>
              <FiActivity />
              <span>Gerçek Zamanlı Üretim Takibi (OEE & TEEP)</span>
            </div>
            <div className={styles["feature-item"]}>
              <FiLayers />
              <span>Kapsamlı Stok ve Sipariş Yönetimi</span>
            </div>
            <div className={styles["feature-item"]}>
              <FiShield />
              <span>Güvenli ve Yetkilendirilmiş Erişim</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Login Form */}
      <div className={styles["login-panel"]}>
        <div className={styles["login-content"]}>
          <div className={styles["login-header"]}>
            <div className={styles["form-logo-wrapper"]}>
              <img
                src={require("../../../assets/logos/logo-1.png")}
                alt="Rovion"
                className={styles["form-logo"]}
              />
            </div>
            <h2 className={styles["login-title"]}>Sisteme Giriş</h2>
            <p className={styles["login-subtitle"]}>
             MESinize erişmek için kimlik bilgilerinizi giriniz
            </p>
          </div>

          <form onSubmit={handleSubmit} className={styles["login-form"]}>
            <div className={styles["input-group"]}>
              <Input
                type="email"
                label="E-posta Adresi"
                placeholder={translate("AUTHENTICATION.ENTER_YOUR_EMAIL")}
                value={formData.email}
                onChange={(value) => setFormData({ ...formData, email: value })}
                disabled={loading}
                required
                prefix={<FiUser />}
              />
            </div>

            <div className={styles["input-group"]}>
              <Input
                type="password"
                label={translate("AUTHENTICATION.PASSWORD")}
                placeholder={translate("AUTHENTICATION.ENTER_YOUR_PASSWORD")}
                value={formData.password}
                onChange={(value) =>
                  setFormData({ ...formData, password: value })
                }
                disabled={loading}
                required
                prefix={<FiLock />}
              />
            </div>

            <Button
              type="submit"
              title={
                loading
                  ? translate("AUTHENTICATION.LOGGING_IN")
                  : translate("AUTHENTICATION.TO_ENTER")
              }
              appearance="primary"
              isBlock={true}
              disabled={loading}
              iconAfter={<FiLogIn />}
            />
          </form>

          <div className={styles["login-footer"]}>
            <p>
              © {new Date().getFullYear()} Rovion.{" "}
              {translate("AUTHENTICATION.ALL_RIGHTS_RESERVED")}
            </p>
          </div>
        </div>
      </div>

      {error && (
        <ToastContainer>
          <Toast id={Date.now()} title={error} appearance="danger" isExpanded />
        </ToastContainer>
      )}
    </div>
  );
}
